import React, { Component, Fragment } from 'react';
import Parking from './../Parking';
import './style.scss';
import { withRouter } from 'react-router';
import PaginationComponent from '../../../../../Components/Pagination';
import './style.scss';

class ParkingSpace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedParkingId: null,
      currentPage: 1,
      postsPerPage: 9,
    };
  }

  parkingSelectHandeler = (id, status) => {
    if (status === 'DRAFT') {
      this.props.history.push(
        '/portal/addparkingspace?parkingId=' + id,
      );
    } else {
      this.setState({ selectedParkingId: id });
      this.props.history.push('/portal/parking-details/' + id);
    }
  };
  paginate = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };
  showSelectedNavCards = e => {
    this.setState({ postsPerPage: e.target.value });
  };
  render() {
    const indexOfLastPage =
      this.state.currentPage * this.state.postsPerPage;
    const indexOfFirstPage =
      indexOfLastPage - this.state.postsPerPage;
    const currentPost = this.props.cardData.slice(
      indexOfFirstPage,
      indexOfLastPage,
    );

    

    return (
      <div className="parking-Overview">
        {this.props.cardData.length ? (
          <div className="parkingSpace">
            <div
              className="parkingSpace__wrapper"
              style={{ padding: '5px 10px 0px' }}
            >
              {
                currentPost.map(
                  (parking, index) => {
                    return (
                      <Fragment key={index}>
                        <Parking
                          parkingId={parking.parkingId}
                          id={index}
                          title={parking.name}
                          address={parking.address}
                          address1={
                            parking.addressDetails.addressLine1
                          }
                          address2={
                            parking.addressDetails.addressLine2
                          }
                          status={parking.status.name}
                          type={parking.parkingBusinessType.name}
                          description={parking.description}
                          contact={parking.contactNumber}
                          email={parking.contactEmail}
                          vehicleTypeInfo={parking.vehicleTypeInfo}
                          links={parking._links}
                          timings={parking.operatingHoursInfo}
                          isVerified={parking.isVerified}
                          {...this.props}
                          clicked={() =>
                            this.parkingSelectHandeler(
                              parking.parkingId,
                              parking.status.name,
                            )
                          }
                        />
                      </Fragment>
                    );
                  },
                )
              }
            </div>

            <div className="navConfig">
              <div className="dropdownNumber">
                <select
                  name="selectNavcards"
                  id="selectNavcards"
                  className="selectNavcards"
                  onChange={this.showSelectedNavCards}
                >
                  <option value={9}>9</option>
                  <option value={18}>18</option>
                  <option value={27}>27</option>
                  <option value={36}>36</option>
                  <option value={45}>45</option>
                </select>
              </div>
              <PaginationComponent
                postsPerPage={this.state.postsPerPage}
                totalPosts={this.props.cardData.length}
                paginate={this.paginate}
              />
            </div>
          </div>
        ) : (
          <div>
            {/* <div className="noParking__wrapper">
                  <img src={noSpace} alt="Parking space icon" />
                  <h4>
                    You don't have any parking space added to your account.
                  </h4>
                  <Link to="/portal/addparkingspace">
                    <Button variant="contained" color="primary">
                      List A Parking Space +
                    </Button>
                  </Link>
                </div> */}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(ParkingSpace);
